import React from 'react';
import TopBarProgress from 'react-topbar-progress-indicator';

const green = '#287433';

TopBarProgress.config({
  barColors: {
    '0': green,
    '1.0': green
  },
  shadowBlur: 5
});

const Loader = props => {
  return (
    // TODO: Remove commented code once new approach approved
    // <div className="loader">
    //   <p className="loader__p">Loading...</p>
    // </div>
    <TopBarProgress />
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/shared/Loader.js